import { authService } from '@/services/authService';

/**
 * Temporary Music-registration-only behaviour.
 *
 * Music applicants must authenticate solely to submit their completed form,
 * then immediately end that session. Keep this outside the shared login flow
 * so Academic registration and ordinary sign-in remain unchanged. Remove this
 * helper when the temporary Music registration requirement is retired.
 */
export const completeMusicRegistrationSession = async (): Promise<void> => {
  await authService.signOut();
};
